(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pickup-box"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === '{{ section.id }}' || event.target.id === 'shopify-section-{{ section.id }}') {
      const carousel = event.target.querySelector('.pickup-carousel');
      if (carousel && typeof $ !== 'undefined' && $.fn.slick) {
        if ($(carousel).hasClass('slick-initialized')) {
          $(carousel).slick('unslick');
        }
        $(carousel).slick({
          autoplay: false,
          dots: false,
          slidesToShow: 4,
          infinite: false,
          prevArrow: '<button class="slick__prev"></button>',
          nextArrow: '<button class="slick__next"></button>',
          responsive: [
            { breakpoint: 620, settings: { slidesToShow: 1.2 } },
            { breakpoint: 980, settings: { slidesToShow: 2.4 } },
            { breakpoint: 1280, settings: { slidesToShow: 2.8 } },
          ],
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
